import React, { useState } from "react";
import { userService } from "../../_services";
import { ConfirmDialog } from "@/components/ui/confirm-dialog";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { CheckCircle } from "lucide-react";

/**
 * Delete Referral URL Confirmation Modal
 * Modernized with shadcn Dialog component
 */
function Delete_referral_url_popup({ 
    toggle_Delete_popup, 
    PopupTitle, 
    PopupMessage, 
    ButtonText, 
    URL_Id, 
    URL_Text 
}) {
    const [messageText, setMessageText] = useState(PopupMessage);
    const [loading, setLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);

    const handleDelete = async () => {
        setLoading(true);
        setIsError(false);

        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const userId = Usermeta_Data.split(':')[0];

            const apidata = await userService.Delete_ReferralURL(URL_Id, URL_Text, userId);

            if (apidata && apidata.length > 0) {
                if (apidata[0].code !== "-1") {
                    setMessageText(apidata[0].message);
                    if (apidata[0].message === "Deleted Successfully") {
                        setIsSuccess(true);
                        setTimeout(() => {
                            toggle_Delete_popup();
                        }, 1500);
                    }
                } else {
                    setMessageText(apidata[0].message);
                    setIsError(true);
                }
            } else {
                setMessageText('Error! Please try later.');
                setIsError(true);
            }
        } catch (error) {
            setMessageText('Error! Please try later.');
            setIsError(true);
            console.error('Error deleting referral URL:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        toggle_Delete_popup();
    };

    return (
        <ConfirmDialog
            open={true}
            onOpenChange={handleClose}
            title={PopupTitle}
            description={!isSuccess && !isError ? messageText : undefined}
            onConfirm={handleDelete}
            onCancel={handleClose}
            confirmText={ButtonText || "Delete"}
            cancelText="Cancel"
            variant="destructive"
            loading={loading}
            confirmDisabled={isSuccess}
            showIcon={true}
        >
            {isSuccess && (
                <Alert variant="success">
                    <CheckCircle className="h-4 w-4" />
                    <AlertDescription>{messageText}</AlertDescription>
                </Alert>
            )}
            {isError && (
                <Alert variant="destructive">
                    <AlertDescription>{messageText}</AlertDescription>
                </Alert>
            )}
        </ConfirmDialog>
    );
}

export default Delete_referral_url_popup;
